import PermissionTableHelper from './permission-table-helper';

const PermissionHelpers = {
    TableMain: PermissionTableHelper,
};

export default PermissionHelpers;